module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icon_trash_48x48.e4cbe3f0.svg";